import { FC, useMemo } from 'react';
import { Text, HStack, VStack, TextProps, chakra } from '@chakra-ui/react';
import { Banner } from '@olo-web/components/atoms/Banner';
import { parsePhoneNumber } from 'libphonenumber-js';

interface I extends TextProps {
  hideTitle?: boolean;
  customer: ICustomer;
}

export const ContactInfoView: FC<I> = (props) => {
  const { hideTitle, customer, ...rest } = props;

  const parsedPhoneNumber = useMemo(() => {
    if (!customer?.phoneNo) return '';
    if (customer?.phoneNo.includes('*')) return customer?.phoneNo;
    const pN =
      customer?.phoneNo[0] !== '+'
        ? parsePhoneNumber(customer?.phoneNo, 'US')
        : parsePhoneNumber(customer?.phoneNo);
    return pN.formatNational();
  }, [customer?.phoneNo]);

  if (!customer)
    return (
      <Banner
        title="No contact info found"
        status="warning"
        description="Please call the restaurant to avoid any confusion"
      />
    );

  return (
    <VStack alignItems="flex-start">
      {!hideTitle && (
        <HStack justify="space-between" align="baseline">
          <Text as="h2" textStyle="h3">
            Contact information
          </Text>
        </HStack>
      )}
      <VStack spacing={1} align="flex-start" fontSize="sm" data-testid="logged-in-user-info">
        <Text {...rest} data-testid="logged-in-user-name">
          <chakra.span fontWeight="semibold">Name:</chakra.span>&nbsp;&nbsp;{customer?.firstName}{' '}
          {customer?.lastName}
        </Text>
        <Text {...rest} data-testid="logged-in-user-email">
          <chakra.span fontWeight="semibold">Email:</chakra.span>&nbsp;&nbsp;{customer?.email}
        </Text>
        <Text {...rest} data-testid="logged-in-user-phone-number">
          <chakra.span fontWeight="semibold">Phone number:</chakra.span>&nbsp;&nbsp;
          {parsedPhoneNumber}
        </Text>
      </VStack>
    </VStack>
  );
};
